import { motion } from 'framer-motion'
import { useEffect, useRef, useState } from 'react'
import Collapsible from 'react-collapsible'
import DotsIcon from '../../../assets/Feed/DotsIcon'
import { HeartIcon, NoHeart } from '../../../assets/Posts/HeartIcon'
import SmallArrowDown from '../../../assets/Posts/SmallArrowDown'
import { api } from '../../../services/api'
import { CommentsResponse } from '../../../services/apiTypes'
import { timeSinceFormatter } from '../../../utils/formatter'
import CommentsModal from '../../Modals/CommentsModal'
import UserIcon from '../../UserIcon'
import SubComment from './SubComment'
import {
  CommentContainer,
  CommentText,
  CommenterName,
  CommenterNameContainer,
  HideTagsContainer,
  LikeCommentContainer,
  MasterContainer,
  MiddleContainer,
  ResponderContainer,
  ResponderText,
  RightContainer,
  SubComments,
  TimeSinceComment,
} from './styles'

type CommentProps = {
  authorAvatarUrl: string;
  index: number;
  authorId: string;
  authorUsername: string;
  publicationUsername: string;
  feedType: string;
  childs: number;
  content: string;
  createdAt: string;
  id: string;
  likes: number;
  parentId: string;
  publicationId: string;
  updatedAt: string;
  handleResponse: (response: string) => void;
  setAnswerTarget: (target: string) => void;
  reloadSubComments: boolean;
  setReloadSubComments: (reload: boolean) => void;
  scrollPosition: number;
  setCommentModalOpen: (open: boolean) => void;
  commentModalOpen: boolean;
  setCommentModalIndex: (index: string) => void;
  commentModalIndex: string;
}

export default function Comment({
  authorAvatarUrl,
  authorId,
  index,
  authorUsername,
  publicationUsername,
  feedType,
  childs,
  content,
  createdAt,
  id,
  likes,
  parentId,
  publicationId,
  updatedAt,
  handleResponse,
  setAnswerTarget,
  reloadSubComments,
  setReloadSubComments,
  scrollPosition,
  setCommentModalOpen,
  commentModalOpen,
  setCommentModalIndex,
  commentModalIndex
}: CommentProps) {
  const [liked, setLiked] = useState(false)
  const [showOptions, setShowOptions] = useState(false)
  const [showSubComments, setshowSubComments] = useState(false);
  const [replies, setReplies] = useState<CommentsResponse[]>([])
  const [likesCount, setLikesCount] = useState(likes)

  useEffect(() => {
    if (reloadSubComments) {
      api.get(`/comments/${id}`).then(response => {
        setReplies(response.data);
        // console.log('replies', response.data)
      }
      );
    }
    setReloadSubComments(false)
  }, [showSubComments, reloadSubComments]);

  const handleAnswer = () => {
    handleResponse('@' + authorUsername + ' ')
    setAnswerTarget(id)
  }

  const handleLike = async () => {
    setLiked(!liked);
    if (!liked) {
      setLikesCount(likesCount + 1)
    } else {
      setLikesCount(likesCount - 1)
    }
    try {
      const response = await api.post(`/comments/like/${id}`)
      if (response.status !== 200 && !liked) {
        setLiked(!liked)
        setLikesCount(likesCount - 1)
      }
    } catch (error) {
      console.log(error)
    }
  }
  const commentRef = useRef<any>(null);
  const [modalPositionComment, setModalPositionComment] = useState<number>(20);

  const handleIconClick = () => {
    if (commentRef.current) {
      setModalPositionComment(20 - scrollPosition);
      if (!commentModalOpen || commentModalIndex === id) {
        setShowOptions(!showOptions);
        setCommentModalOpen(!commentModalOpen);
        setCommentModalIndex(id);
      }
    }
  };

  return (
    <MasterContainer>
      <CommentContainer>
        <UserIcon size='m' icon={authorAvatarUrl} />
        <MiddleContainer>
          <CommenterNameContainer>
            <CommenterName>
              {authorUsername}
            </CommenterName>
            <TimeSinceComment>{timeSinceFormatter(createdAt)}</TimeSinceComment>
          </CommenterNameContainer>
          <CommentText>
            {content}
          </CommentText>
          <ResponderContainer onClick={() => handleAnswer()} >
            <ResponderText style={{ cursor: 'pointer' }}>Responder</ResponderText>
            <LikeCommentContainer onClick={() => handleLike()}>
              {liked ? <HeartIcon /> : <NoHeart />}
              <ResponderText>{likesCount}</ResponderText>
            </LikeCommentContainer>
            <HideTagsContainer>
              <ResponderText>{replies?.length ? `${replies?.length}` + ' respostas' : ' '}</ResponderText>
              {replies && replies.length > 0 &&
                <motion.div
                  whileHover={{ scale: 1.5 }}
                  style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                  animate={{ rotate: showSubComments ? 0 : 180 }}
                  transition={{ duration: 0.7, ease: [0.04, 0.62, 0.23, 0.98] }}
                  onClick={() => setshowSubComments(!showSubComments)}
                >
                  <SmallArrowDown />
                </motion.div>
              }
            </HideTagsContainer>
          </ResponderContainer>
        </MiddleContainer>
        <CommentsModal
          commentId={id}
          onAction={() => setShowOptions(false)}
          authorUsername={authorUsername}
          open={showOptions}
          publicationUsername={publicationUsername}
          scrollY={modalPositionComment}
          feedType={feedType}
        />
        <RightContainer ref={commentRef} onClick={() => handleIconClick()}>
          <DotsIcon />
        </RightContainer>
      </CommentContainer>
      <Collapsible
        open={showSubComments}
        trigger={''}
        style={{ height: '100%' }}
      >
        <SubComments>
          {replies && replies.map((comment, index) => (
            <SubComment
              key={index}
              index={index}
              authorAvatarUrl={comment.authorAvatarUrl}
              authorId={comment.id}
              authorUsername={comment.authorUsername}
              publicationUsername={publicationUsername}
              content={comment.content}
              createdAt={comment.createdAt}
              id={comment.id}
              likes={comment.likes}
              parentId={comment.parentId}
              feedType={feedType}
              publicationId={comment.publicationId}
              updatedAt={comment.updatedAt}
              childs={comment.childs}
              handleResponse={handleResponse}
              setAnswerTarget={setAnswerTarget}
              scrollPosition={scrollPosition}
              setCommentModalOpen={setCommentModalOpen}
              commentModalOpen={commentModalOpen}
              setCommentModalIndex={setCommentModalIndex}
              commentModalIndex={commentModalIndex}
            />
          ))}
        </SubComments>
      </Collapsible>
    </MasterContainer>
  )
}